<template>
  <div class="yx-dxjt-page main-layout">
    <!-- <BackToPrePage /> -->
    <CCollapseItem>
      <template slot="title-left">
        <i
          class="iconfont icon-fanhui"
          @click.stop="$router.go(-1)"
          style="font-size: 20px; margin-right: 10px"
        ></i>
        <span>报到行程统计</span>
      </template>
      <template slot="body">
        <c-search
          v-model="pageParams"
          :searchItems="searchItems"
          @reset="refresh"
          @search="pageGet(true)"
        >
        </c-search>
      </template>
    </CCollapseItem>
    <el-card class="box-table box-bottom">
      <div slot="header" class="btn-group">
        <!-- 操作按钮 -->
        <div class="btn-left">
          <div class="opt-btn" title="导出" @click="exportExcel">
            <i
              class="iconfont icon-daochu3"
              :class="{ disabled: isExport }"
            ></i>
          </div>
        </div>
        <!-- 右侧操作按钮 -->
        <table-btns
          :tableColumns="tableColumns"
          @tableColumnsChange="tableColumnsChange"
          @refresh="
            idList = [];
            pageGet(true);
          "
        ></table-btns>
      </div>
      <c-table
        :data="pageData"
        :tableColumns="tableColumns"
        :pagination="pageParams"
        @change="pageGet"
        @selectionChange="selectionChange"
        v-loading="pageLoading"
      >
        <template slot="status" slot-scope="scope">
          <span
            @click="handleShowAccompany(scope.row.entourageList)"
            class="accompany-count"
            >{{ scope.row.entourageList.length }}</span
          >
        </template>
        <template slot="custom" slot-scope="scope">
          <div class="contr-btn-group">
            <div
              class="contr-btn"
              title="详情"
              @click="handeShowDetail(scope.row.id)"
            >
              <img src="../../../../../assets/images/icon/detail.png" />
            </div>
          </div>
        </template>
      </c-table>
    </el-card>
    <el-dialog
      :close-on-click-modal="false"
      :title="dialogType == 'accompany' ? '随行人员' : '详情'"
      :visible.sync="dialogVisible"
      width="50%"
    >
      <c-table
        :data="accompanyData"
        :tableColumns="dialogTableColumns"
        v-if="dialogType == 'accompany'"
      >
      </c-table>
      <div class="pre-detail-container" v-if="dialogType == 'detail'">
        <div class="div-scroll">
          <c-des
            :span="1"
            :desItems="desItems"
            :value="detailInfo"
            :column="1"
            :labelStyle="{ width: '120px' }"
          >
          </c-des>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MPage from "@/mixins/MPage.js";
import Configs from "./data/dxjt";
import { getOrgOptions } from "@/libs/searchSelect.js";
import { mapState } from "vuex";
let mPage = MPage({
  pagePath: "/welcome-forecast/transport/listPage",
  pageDelPath: "",
  pageDelsPath: "",
  pageParams: {
    collegeId: "",
    grade: "",
    majorId: "",
    classId: "",
    classIdList: [],
    academicDegree: "",
    academicYear: "",
    studentNoOrName: "",
    sex: "",
    trafficType: "",
    trainInfo: "",
    timeRange: [],
    startTime: "",
    endTime: "",
  },
  pageExportPath: "/welcome-forecast/transport/exportExcel",
  pageExportParams: {},
});
export default {
  mixins: [mPage],
  data() {
    let { searchItems, tableColumns, dialogTableColumns, desItems } = Configs(
      this
    );
    return {
      isFold: false,
      searchItems,
      tableColumns,
      dialogTableColumns,
      desItems,
      idList: [],
      dialogVisible: false,
      accompanyData: [], // 随行人员数据
      dialogType: "",
      detailInfo: {},
      isExport: false, // 是否导出
      message: null,
      timeTypeName: ["", "上午", "下午", "晚上"],
    };
  },
  computed: {
    ...mapState("dic", [
      "SUCCESS_CODE",
      "_CURRENTYEAR",
      "_COLLEGE_ID",
      "_CURRENT_ACADEMIC",
    ]),
  },
  created() {
    this.setCollegeId();
  },
  mounted() {},
  methods: {
    setCollegeId() {
      if (this._COLLEGE_ID) {
        this.pageParams.collegeId = this._COLLEGE_ID;
        getOrgOptions(
          this,
          { parentId: this._COLLEGE_ID, type: "department" },
          1,
          null
        );
      }
    },
    getWelcomeStation() {
      this.$http
        .get("/welcome-forecast/welcome-car/listPage")
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.searchItems[6].options = res.data.records.map((item) => {
              return {
                label: item.location,
                value: item.id,
              };
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    selectionChange(data) {
      let idList = [];
      if (data.length) {
        data.forEach((item) => {
          idList.push(item.studentId);
        });
        this.idList = idList;
      }
    },
    handleDelBatch() {
      if (this.idList.length) {
        this.pageDels(this.idList);
      } else {
        this.$message({
          message: "请选择需要删除的数据！",
          type: "warning",
        });
      }
    },
    pageDelAfterFn() {
      this.idList = [];
      this.pageGet(true);
    },
    pageGetBeforeFn(data) {
      let params = Object.assign({}, data);
      if (!params.academicDegree)
        params.academicDegree = this._CURRENT_ACADEMIC;
      params.enrollmentYear = this._CURRENTYEAR[0].value;
      params.classId = params.classIdList.join(",");
      delete params.classIdList;
      if (params.timeRange && params.timeRange.length) {
        params.startTime = params.timeRange[0];
        params.endTime = params.timeRange[1];
      }
      delete params.timeRange;
      return params;
    },
    refresh() {
      this.idList = [];
      this.searchItems[2].options = [];
      this.searchItems[3].options = [];
      this.pageParams = {
        collegeId: "",
        grade: "",
        majorId: "",
        classId: "",
        classIdList: [],
        academicDegree: "",
        academicYear: "",
        studentNoOrName: "",
        sex: "",
        trafficType: "",
        trainInfo: "",
        timeRange: [],
        startTime: "",
        endTime: "",
      };
      this.setCollegeId();
      this.pageGet(true);
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
    exportExcel() {
      if (this.isExport) {
        return;
      } else {
        this.isExport = true;
        this.message = this.$message({
          message: "数据正在导出中，请稍候！",
          duration: 0,
          type: "warning",
          center: true,
        });
        let params = Object.assign({}, this.pageParams);
        if (!params.academicDegree)
          params.academicDegree = this._CURRENT_ACADEMIC;
        params.enrollmentYear = this._CURRENTYEAR[0].value;
        if (params.timeRange && params.timeRange.length) {
          params.startTime = params.timeRange[0];
          params.endTime = params.timeRange[1];
        }
        delete params.timeRange;
        params.classId = params.classIdList.join(",");
        delete params.classIdList;
        this.pageExportParams = params;
        if (this.idList.length) {
          this.pageExportParams.studentIdStr = this.idList.join();
        }
        // let filename = "报到行程统计.xls";
        this.pageExport();
      }
    },
    pageExportAfterFn() {
      this.isExport = false;
      this.message.close();
      this.message = null;
      this.refresh();
      this.pageExportParams = {};
    },
    // 显示随行人员详情弹框
    handleShowAccompany(data) {
      if (data.length) {
        this.accompanyData = data || [];
        this.dialogType = "accompany";
        this.dialogVisible = true;
      } else {
        return this.$alert("暂无随行人员信息", "提示", {
          confirmButtonText: "确定",
          type: "warning",
        });
      }
    },
    // 查看详情
    handeShowDetail(id) {
      this.dialogType = "detail";
      this.dialogVisible = true;
      this.$http
        .get("/welcome-forecast/transport/" + id)
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.detailInfo = res.data || {};
            this.detailInfo.timeTypeName = this.timeTypeName[
              Number(res.data.timeType)
            ];
          } else {
            this.$message.error(res.msg);
            this.detailInfo = {};
          }
        })
        .catch((err) => {
          this.$message.error(err + "获取详情失败");
          this.detailInfo = {};
        });
    },
  },
};
</script>
